import React from "react";
import { useApiDocsContext } from "../startup/ApiDocsApp";
import MethodBadge from "./MethodBadge";
import AuthBadge from "./AuthBadge";
import ParameterTable from "./ParameterTable";
import CodeExampleTabs from "./CodeExampleTabs";
import ResponseExample from "./ResponseExample";

const EndpointDetail = () => {
  const { selectedEndpoint } = useApiDocsContext();

  if (!selectedEndpoint) return null;

  return (
    <div className="api-docs-endpoint-detail">
      <div className="api-docs-endpoint-header">
        <span className="api-docs-endpoint-category-label">
          {selectedEndpoint.categoryName}
        </span>
        <h1 className="api-docs-endpoint-title">{selectedEndpoint.summary}</h1>
        <div className="api-docs-endpoint-meta">
          <MethodBadge method={selectedEndpoint.method} />
          <code className="api-docs-endpoint-path">{selectedEndpoint.path}</code>
          <AuthBadge auth={selectedEndpoint.auth} />
          {selectedEndpoint.isAdmin && (
            <span className="api-docs-admin-notice">
              Requires Opendate admin access
            </span>
          )}
        </div>
      </div>

      {selectedEndpoint.description && (
        <p className="api-docs-endpoint-description">
          {selectedEndpoint.description}
        </p>
      )}

      <ParameterTable parameters={selectedEndpoint.parameters} />

      <CodeExampleTabs endpoint={selectedEndpoint} />

      <ResponseExample responses={selectedEndpoint.responses} />
    </div>
  );
};

export default EndpointDetail;
